import apiClient from "../../utilities/apiService";
const BASE_URL = process.env.REACT_APP_BACKEND_URL;
  
  // Fetch admin data with pagination
export const fetchAdminList = async (page, size) => {
    try {
      const response = await apiClient.get(`${BASE_URL}/admin/user/adminList`, {
        params: { page: page - 1, size }, // 0-based indexing for API
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  };

// remove  Admin
export const removeAdmin = async (userId) => {
    try {
      const response = await apiClient.post(
        `${process.env.REACT_APP_BACKEND_URL}/admin/user/updateRole/${userId}`,
        {
          id: userId,
          role: "ROLE_USER",
        }
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  };